import styled from "styled-components";
import { useTranslation } from "react-i18next";
import Logo from "../../assets/logo/kb-logo-2.png";
import CallCenter from "../../assets/images/call-center.png";
import { Printer, Facebook2, Instagram2, Twitter2, Youtube } from "../icons";
import { Row, Col } from "react-bootstrap";
import { ChevronRight, Phone } from "../icons";
import { ContainerFrame } from ".";
import { DirectoryAPI, SettingsAPI } from "@api";
import { useState, useEffect } from "react";

const Container = styled.div``;

const ContainerNavigation = styled.div`
  display: flex;
  align-items: center;
  padding: 24px 119px;
  height: 3vh;
  border-top: #edeeee 1px solid;
  border-bottom: #edeeee 1px solid;

  @media screen and (max-width: 767px) {
    padding: 24px;
  }

  .icon-logo-bukopin {
    display: flex;
    align-items: center;

    img {
      width: 159px;
      height: 24px;
      object-fit: cover;
    }
  }

  .icon-chevron-right {
    margin: 0 23px 0 24px;

    @media screen and (max-width: 767px) {
      margin: 0 16px;
    }
    svg {
      width: 24px;
      height: 24px;
    }
  }

  .current-page-title {
    padding-top: 3px;
    font-weight: normal;
    font-size: 16px;
    line-height: 32px;
    color: #5e514d;    
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const ContainerLinkTree = styled.div`
  position: relative;
  font-size: 0.8em;
  color: #fff;
  background: #776e64;
  padding: 3em 1em 3em 0;
  width: -webkit-fill-available;

  & ul {
    list-style-type: none;
    padding: 0;

    & li {
      height: 3em;
      color: #d0d0d0;

      &:hover {
        font-weight: bold;
      }

      & a {
        color: #d0d0d0;
        text-decoration: none;
      }
    }
  }
`;

const ContainerLinkTreeImage = styled.img`
  width: 20em;
  bottom: 5em;
  right: 5em;
`;

const ContainerLink = styled.div`
  & div {
    padding-bottom: 1em;
  }
`;

const ContainerFooter = styled.div`
  position: relative;
  font-size: 0.8em;
  padding: 3em 1em 2em 0;
  width: -webkit-fill-available;
  background: #f9f9f9;
  color: #5e514d;
`;

const ContainerFooterFollowUs = styled.div``;

const ContainerFooterImage = styled.img`
  height: 4em;
`;

const ContainerFooterIcon = styled.a`
  width: 40px;
  height: 40px;
  backgorund-color: #fff;
  box-shadow: 0px -1px 2px rgba(0, 0, 0, 0.05), 0px 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  margin-right: 10px !important;
  display: flex;
  justify-content: center;
  align-items: center;

  svg{
    width: 24px;
    height: 24px;
  }

  &:last-child{
    margin-right: 0 !important;
  }

  &:hover {
    opacity: 0.8;
  }
`;

const PhoneNumber = styled.div`
  display: flex;
  padding: 1em 0;
`;

const CopyRight = styled.div`
  background: #5e514d;
  color: white;
  text-align: left;
  font-size: 0.8em;
  padding: 24px 123px;
  @media (max-width: 576px) {
    padding: 16px;
  }
`;

const FooterSection = function ( props ) {
  const { t, i18n } = useTranslation();

  const [directory, setDirectory] = useState(null);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    const loadDirectory = async function () {
      const directoryData = await DirectoryAPI();
      setDirectory(directoryData.data["footer"]);
    };

    const loadSettings = async function () {
      const settingsData = await SettingsAPI();
      setSettings(settingsData.data.data);
    };

    if (!directory) {
      loadDirectory();
    }

    if (!settings) {
      loadSettings();
    }
  }, [directory, settings]);

  return (
    <Container>
      <ContainerNavigation>
        <div className="icon-logo-bukopin">
          <img src={Logo} alt="Logo" />
        </div>
        <div className="icon-chevron-right">
          <ChevronRight fill="#5E514D" />
        </div>
        <div className="current-page-title">{props.currentPage}</div>
      </ContainerNavigation>
      <ContainerLinkTree className="text-start">
        <ContainerFrame>
          <Row>
            {directory != null
              ? directory.map((data, i) => {
                  return (
                    <Col xs="12" md="4" key={i}>
                      <ContainerLink>
                        <div>{t(data.title)}</div>
                        <ul>
                          {data.subdirectory.map((subdir, i) => {
                            return (
                              <li key={i}>
                                <a href={subdir.link} target="_blank" rel="noreferrer">{t(subdir.label)}</a>
                              </li>
                            );
                          })}
                        </ul>
                      </ContainerLink>
                    </Col>
                  );
                })
              : ""}

            <Col xs="12" md={{ offset: 4, span: 4 }}>
              <ContainerLinkTreeImage src={CallCenter} />
            </Col>
          </Row>
        </ContainerFrame>
      </ContainerLinkTree>
      <ContainerFooter className="text-start">
        <ContainerFrame>
          <Row>
            <Col xs="12" md="2">
              <ContainerFooterFollowUs>
                <div style={{ paddingBottom: "1em" }}>{t("follow_us")}</div>
                <Row>
                  <Col className="d-flex">
                    <ContainerFooterIcon href="https://www.facebook.com/kbbank.id" target="_blank" rel="noreferrer">
                      <Facebook2 fill="#5E514D" />
                    </ContainerFooterIcon>
                    <ContainerFooterIcon href="https://x.com/kbbank_id" target="_blank" rel="noreferrer">
                      <Twitter2 fill="#5E514D" />
                    </ContainerFooterIcon>
                    <ContainerFooterIcon href="https://www.instagram.com/kbbank.id/" target="_blank" rel="noreferrer">
                      <Instagram2 fill="#5E514D" />
                    </ContainerFooterIcon>
                    <ContainerFooterIcon href="https://www.youtube.com/@kbbank_id" target="_blank" rel="noreferrer">
                      <Youtube fill="#5E514D" />
                    </ContainerFooterIcon>
                  </Col>
                </Row>
              </ContainerFooterFollowUs>
            </Col>
            <Col xs="12" md="5" className="pb-4">
              <div>
                <div>{t("kantor_pusat")}</div>
                <div>
                  <div>{t("gedung_bank_kb_bukopin")}</div>
                  <div>{settings !== null ? settings.address_alamat : ""}</div>
                  <PhoneNumber>
                    <div style={{ width: "50%", display: "flex" }}>
                      <div style={{ paddingRight: "1em", alignSelf: "center" }}>
                        <Phone height="1.5em" width="1.5em" fill="#5e514d" />
                      </div>
                      <div style={{ alignSelf: "center" }}>
                        {settings !== null ? settings.no_telp : ""}
                      </div>
                    </div>
                    <div style={{ width: "50%", display: "flex" }}>
                      <div style={{ paddingRight: "1em", alignSelf: "center" }}>
                        <Printer height="1.5em" width="1.5em" fill="#5e514d" />
                      </div>
                      <div style={{ alignSelf: "center" }}>
                        {settings !== null ? settings.fax : ""}
                      </div>
                    </div>
                  </PhoneNumber>
                </div>
              </div>
            </Col>
            <Col xs="12" md="5">
              <div style={{ paddingBottom: "1em", textAlign: "justify" }}>{t("disclaimer1")}</div>
              <div style={{ paddingBottom: "1em", textAlign: "justify" }}>{t("disclaimer2")}
                <a href='https://apps.lps.go.id/BankPesertaLPSRate'>
                  {i18n.language === "id" ? "di sini" : "here"}
                </a>
              </div>
            </Col>
          </Row>
        </ContainerFrame>
      </ContainerFooter>
      <CopyRight>
        Copyright © KB Bank 2024 All rights reserved.
      </CopyRight>
    </Container>
  );
};

export default FooterSection;
